module.exports = __webpack_public_path__ + "static/img/service.79e9d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/service.png
// module id = 6dJ1
// module chunks = 0